var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-scale-transition',[_c('kits-panel',{attrs:{"kits-items":_vm.royaltyIncentiveKits,"breadcrumbs":_vm.breadcrumbs}},[_c('h3',{staticClass:"headline grey--text text-xs-center hidden-sm-and-down"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }